function cssToString(obj)
{
  return Object.entries(obj).reduce((str, [p, val]) => {
    return `${str}${p}: ${val};\n`;
  }, '');
}

export {cssToString};
